import React, { useEffect, useState } from 'react';
import NavbarOne from './separate/NavbarOne';
import Config from '../core/config';
import { makeRequest } from '../core/services/v1/request';
import Loader from '../Component/Loader/Loader';
import { useParams, Link } from 'react-router-dom';
import { Typography, Box, Paper } from '@mui/material';
import { dateFormatOKX } from '../core/helper/date-format';
import Footer from './separate/Footer';
import { Helmet } from 'react-helmet-async';
import BlogsDetailsFAQ from './BlogsDetailsFAQ';
import PageTitleDes from '../core/support/PageTitleDes';

const CommonWrap = ({ children, setTheme, theme }) => {
    return (
        <>
            <NavbarOne setTheme={setTheme} theme={theme} />
            <Box className="bg-default text-white" sx={{ minHeight: "100vh" }}>
                <div className="container pt-5 pb-3">{children}</div>
            </Box>
            <Footer />
        </>
    );
};

const BlogsDetails = (props) => {
    const [loading, setLoading] = useState(true);
    const [blog, setBlog] = useState(null);
    const [related, setRelated] = useState([]);
    const { link, cat = '' } = useParams();

    const fetchData = async () => {
        try {
            setLoading(true);

            const params = {
                url: `${Config.V2_API_URL}cms/getBlog/${cat ? cat + '/' : ''}${link}`,
                method: 'GET',
            };

            const res = await makeRequest(params);

            if (res.status && res.blog) {
                setBlog(res.blog);
                setRelated(res.relatedBlogs || []);
            }

            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        fetchData();
    }, [link]);


    if (loading) {
        return (
            <>
                <PageTitleDes
                    title="Crypto Blog | Latest News, Insights & Market Trends"
                    description="Stay updated with the latest cryptocurrency news, trading insights, and market trends from Unitic Exchange experts."
                />
                <CommonWrap setTheme={props.setTheme} theme={props.theme}>
                    <Loader />
                </CommonWrap>
            </>
        );
    }

    if (!loading && !blog) {
        return (
            <>
                <PageTitleDes
                    title="Crypto Blog | Latest News, Insights & Market Trends"
                    description="Stay updated with the latest cryptocurrency news, trading insights, and market trends from Unitic Exchange experts."
                />
                <CommonWrap setTheme={props.setTheme} theme={props.theme}><h4 className="text-center pt-4">No Blog Found</h4></CommonWrap>
            </>

        );
    }
    return (
        <>
            <PageTitleDes title={blog?.metaTitle || 'Crypto Blog | Latest News, Insights & Market Trends'} description={blog?.metaDesc || 'Stay updated with the latest cryptocurrency news, trading insights, and market trends from Unitic Exchange experts.'} keywords={
                blog?.keywords?.length > 0
                    ? blog.keywords
                    : [
                        "Best crypto exchange for beginners India",
                        "crypto exchange India",
                        "buy sell crypto coin",
                        "crypto trading exchange",
                        "trading India",
                        "crypto news today",
                        "coin market",
                        "where buy crypto exchange",
                        "best app to buy crypto exchange",
                        "Bitcoin trading tips strategies",
                        "How to make money trading crypto",
                        "Bitcoin signals",
                        "Free signals for crypto",
                        "How to trade bitcoin",
                        "How to trade crypto",
                        "Crypto signals experts",
                        "Free signals for bitcoin",
                        "Free signals for ETH",
                        "Free crypto signal provider",
                        "Free signal for crypto spot",
                        "100% Accuracy signals Indian crypto exchange",
                        "Best crypto exchange in India",
                        "How to buy cryptocurrency in India",
                        "How to trade crypto futures in India",
                        "What are crypto signals?",
                        "Are crypto signals profitable?",
                        "Taxes on cryptocurrency in India",
                        "Lowest fees crypto exchange India",
                        "Mobile app for crypto trading India",
                        "Secure crypto exchange India",
                        "Crypto exchange with high liquidity India",
                        "Free crypto signals India",
                        "Bitcoin Trading Tips & Strategies",
                        "Bitcoin Trading Strategy Guide",
                        "Bitcoin Signals 99% success",
                        "Bitcoin Signals High Win Rate",
                        "Free Signals for crypto",
                        "Bitcoin Trading Free Signals",
                        "Bitcoin Trading For Beginners",
                        "Crypto Signals Experts",
                        "Crypto Trading Tips Free",
                        "Free signal for ETH",
                        "Free Crypto Signals provider",
                        "Free signals for crypto feature",
                        "Free Signals for crypto spot",
                        "100% Accuracy signal for crypto",
                        "crypto exchange India",
                        "buy sell crypto coin",
                        "best cryptocurrency exchange",
                        "crypto trading platform",
                        "digital currency exchange",
                        "bitcoin exchange India",
                        "Ethereum exchange",
                        "Litecoin exchange",
                        "ripple",
                        "ripple exchange",
                        "cryptocurrency market",
                        "crypto wallet",
                        "crypto trading India",
                        "crypto investment platform",
                        "crypto exchange platform",
                        "top cryptocurrency exchange",
                        "crypto exchange rates",
                        "crypto exchange website",
                        "crypto exchange services",
                        "crypto exchange platform India",
                        "crypto exchange market",
                        "crypto exchange fees",
                        "crypto exchange comparison",
                        "crypto exchange reviews",
                        "crypto exchange news",
                        "Sell Bitcoin India",
                        "Crypto spot trading India",
                        "Crypto futures trading India",
                        "Buy Crypto in India",
                        "Cryptocurrency exchange India",
                        "Best Apps for Cryptocurrency in India",
                        "Top Cryptocurrency Consultants in Chennai",
                        "Best Crypto Currency Exchange in India",
                        "Crypto Exchange & Tron Exchange from Chennai",
                        "Crypto exchange in Chennai India app",
                        "Crypto exchange in Chennai India price",
                        "Free crypto exchange in Chennai India",
                        "Online crypto exchange in Chennai India",
                        "Buy Bitcoin & Cryptocurrency in India",
                        "Best Crypto Exchanges & Apps in India for 2024",
                        "Cryptocurrency Exchange Development Company in India",
                        "How to buy Bitcoins in Chennai",
                        "Bitcoin and cryptocurrency exchange & trading platform",
                        "Buy Sell Trade BTC XRP ETH TRX",
                        "Sign up for crypto exchange India",
                        "Crypto exchange with expert signals India",
                        "Crypto exchange regulations",
                        "crypto exchange security",
                        "crypto exchange API",
                        "Unitic",
                        "Crypto",
                        "Trade",
                        "Sell",
                        "Crypto Trading",
                        "Trading Fees",
                        "Exchange",
                        "bitcoin",
                        "crypto currency",
                        "coin dcx",
                        "cryptocurrency trading",
                        "crypto news",
                        "crypto news today",
                        "today crypto news",
                        "cap market",
                        "cryptocurrency price",
                        "crypto prices",
                        "crypt market",
                        "cryptocurrency news",
                        "crypto trading for beginners",
                        "trading crypto for beginners",
                        "coin market",
                        "crypto meaning"
                    ]
            }
                image={blog?.image}
                url={`https://www.uniticexchange.com/blog/${link}`} />

            <CommonWrap setTheme={props.setTheme} theme={props.theme}>
                {!loading && blog && (
                    <div className="row g-5">
                        <div className="col-lg-8">
                            <Paper elevation={4} className="blogCardPremium">

                                {/* <Typography variant="h4" className="blogTitle">
                                        {blog?.title}
                                    </Typography> */}
                                <h1 className="blogTitle">{blog?.title}</h1>

                                <div className="blogMeta">
                                    <span className="blogDate">
                                        {dateFormatOKX(blog?.dateTime)}
                                    </span>
                                </div>

                                {(blog?.image || blog?.loaderIcon) && (
                                    <img
                                        src={blog?.image || blog?.loaderIcon}
                                        alt={blog?.title || "blog image"}
                                        className="blogBanner img-fluid"
                                    />
                                )}

                                <hr className="dividerSoft" />

                                <div
                                    className="premiumBlogContent"
                                    dangerouslySetInnerHTML={{ __html: blog.description }}
                                ></div>
                            </Paper>
                            {blog?.faqs && blog?.faqs.length > 0 ? <BlogsDetailsFAQ faqs={blog?.faqs} /> : null}
                        </div>

                        <div className="col-lg-4">
                            <Paper elevation={4} className="relatedBox stickySidebar">
                                <Typography variant="h4" className="relatedTitle">
                                    Popular Articles
                                </Typography>
                                {related.length === 0 && (
                                    <p className="text-white">No Related Articles Found.</p>
                                )}

                                {related.map((item) => (
                                    <Link
                                        to={`${item.link}`}
                                        key={item._id}
                                        className="relatedItem"
                                    >
                                        <img
                                            src={item.image}
                                            alt={item.title}
                                            className="relatedImg"
                                        />

                                        <div className="relatedText">
                                            <p className="relatedHeadline">
                                                {item.title}
                                            </p>
                                            <span className="relatedDate">
                                                {dateFormatOKX(item.dateTime)}
                                            </span>
                                        </div>
                                    </Link>
                                ))}
                            </Paper>
                        </div>

                    </div>
                )}
            </CommonWrap>
        </>
    );
};

export default BlogsDetails;
